import { render } from "./links.vue?vue&type=template&id=876d97fa&lang=pug"
import script from "./links.vue?vue&type=script&lang=js"
export * from "./links.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__